import React, { useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useResetToAppliedFilter } from './hooks';
import { FilterContainer, FilterBox, ButtonContainer, StyledButton } from './filter.styles';

const Filter = ({ open, setModalOpen, handleFetchFilterData, children }) => {
  const filterRef = useRef(null);
  const pristine = useSelector(s => s.listFilter?.pristine, shallowEqual);
  const resetToAppliedFilter = useResetToAppliedFilter();

  const handleFilterModal = () => {
    if (open) {
      resetToAppliedFilter();
    }
    setModalOpen(!open);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      const isInsideFilter = filterRef.current && filterRef.current.contains(event.target);
      const isInsideAutoComplete = event.target?.id?.startsWith('filter-') ||
        event.target?.parentNode?.id?.startsWith('filter-');
      const isInsideSearch = event.target?.id?.startsWith('list-search') ||
      event.target?.parentNode?.id?.startsWith('list-search');

      const isClickOutside = !isInsideFilter && !isInsideAutoComplete && !isInsideSearch;

      if (isClickOutside) {
        setModalOpen(false);
        resetToAppliedFilter();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [resetToAppliedFilter, setModalOpen]);

  const handleApply = () => {
    handleFetchFilterData();
    setModalOpen(false);
  };

  return (
    <FilterContainer ref={filterRef} aria-label="Filter container">
      <FilterBox>
        {children}
        <ButtonContainer>
          <StyledButton
            variant="outlined"
            onClick={handleFilterModal}
          >
            Cancel
          </StyledButton>
          <StyledButton
            type="submit"
            variant="contained"
            color="secondary"
            onClick={handleApply}
            disabled={pristine}
          >
            Apply
          </StyledButton>
        </ButtonContainer>
      </FilterBox>
    </FilterContainer>
  );
};

export default Filter;
